import axios from 'axios';
import Button from 'components/CustomButton/CustomButton.jsx';
import moment from 'moment';
import immutable from 'object-path-immutable';
import React, { Component } from 'react';
import { Col, Grid, MenuItem, Nav, NavDropdown, Row } from 'react-bootstrap';
import { DateRange } from 'react-date-range';
import * as rdrLocales from 'react-date-range/src/locale';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import Select from 'react-select';
import Switch from 'react-switch';
import { bindActionCreators } from 'redux';
import Loading from '../../components/Loading';
import auth from '../../libCustom/auth';
import * as ClientsActions from '../../views/Clients/redux/ClientsActions';
import * as QuotationsActions from '../../views/Quotations/redux/QuotationsActions';
import WidgetSearchName from './widget-searchName';
//import WidgetsReaction from '../../components/Widgets/widget-reaction';
import Logo from '../../assets/img/Icono.png';
import ListItem from '../../components/ListItem/ListItem';
import styled from 'styled-components';
import feathers from '../../feathers';

import { calendarDayToUtc } from '../../libCustom/travelDates';

const options = [
  { value: 'Nacional', label: 'Nacional' },
  { value: 'Internacional', label: 'Internacional' },
];

let people = [];
for (let i = 0; i <= 100; i++) {
  people.push({ value: i, label: i });
}

const list = [
  /*   { label: 'Lorem Ipsum has been the industrys standard dummy ' },
  {
    label:
      'Lorem Ipsum is simply dummy text of the printing and typesetting industry'
  },
  { label: 'Lorem Ipsum has been the industrys standard dummy ' },
  { label: 'Lorem Ipsum has been the industrys standard dummy ' } */
];

const saludation = [
  { value: '', label: '-- Seleccionar' },
  { value: 'Sr.', label: 'Sr.' },
  { value: 'Sra.', label: 'Sra.' },
  { value: 'Srta.', label: 'Srta.' },
  { value: 'Dr.', label: 'Dr.' },
  { value: 'Lic.', label: 'Lic.' },
  { value: 'Arq.', label: 'Arq.' },
  { value: 'Ing.', label: 'Ing.' },
  { value: 'Mtro.', label: 'Mtro.' },
  { value: 'Joven', label: 'Joven' },
];

const fromArray = [
  { value: '', label: '-- Seleccionar' },
  { value: 'Redes sociales', label: 'Redes sociales' },
  { value: 'Recomendación', label: 'Recomendación' },
  { value: 'Publicidad', label: 'Publicidad' },
  { value: 'others', label: 'Otros' },
];
class HeaderLinks extends Component {
  constructor(props) {
    super(props);

    this.currentUser = this.state = {
      loading: false,
      clientData: {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        notes: '',
        findClient: false,
        saludation: '',
        reaction: '',
        from: '',
        otherContact: '',
      },
      formData: {
        userId: auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
        validDate: '',
        destination: '',
        interest: '',
        adults: '',
        juniors: '',
        kids: '',
        notesQuotation: '',
        assignedTo:
          auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
        executive: auth.getCurrentUser() !== null ? auth.getCurrentUser() : '',
        group: false,
        down: false,
        status: 'leats',
      },
      dates: {
        departureDate: calendarDayToUtc(moment()),
        returnDate: calendarDayToUtc(moment()),
        openDate: false,
        duration: '',
      },
      showModal: false,
      optionsSelect: {
        users: [],
        clients: [],
      },
      openDateDisabled: false,
      days: 0,
      listSalesNotifications: [],
    };
    this.handleStorageChange = this.handleStorageChange.bind(this);
  }

  async componentWillMount() {
    if (!auth.verifyLogin()) return false;

    const franchiseId = auth.getCurrentUser().franchiseId;
    const idUser = auth.getCurrentUser().id;

    const params = {
      fields: {
        emailConfiguration: false,
        roles: false,
        firstName: true,
        lastName: true,
        id: true,
      },
      where: {
        franchiseId: franchiseId,
      },
    };

    const objectUser = {
      idUser,
      franchiseId,
    };

    const informationNotification = await feathers
      .service('notifications')
      .get(null, { query: objectUser });

    if (informationNotification && informationNotification.total > 0) {
      let listSalesNotifications = informationNotification.data.map((sale) => {
        return {
          id: sale.id,
          label: sale.label,
          color: sale.color,
        };
      });

      localStorage.setItem(
        'listSalesNotifications',
        JSON.stringify(listSalesNotifications)
      );

      this.setState({ listSalesNotifications });

      window.addEventListener('storage', this.handleStorageChange);
    }

    this.getOptionsSelect(
      'users',
      process.env.REACT_APP_URL_API +
        '/api/users?filter=' +
        JSON.stringify(params),
      (option) => {
        return {
          label: option.firstName + ' ' + option.lastName,
          value: option.id,
        };
      }
    );
  }

  componentWillUnmount() {
    window.removeEventListener('storage', this.handleStorageChange);
  }

  handleStorageChange(event) {
    if (event.key === 'listSalesNotifications') {
      this.setState({ listSalesNotifications: JSON.parse(event.newValue) });
    }
  }

  logout = () => {
    auth.logout();
  };

  onCloseModal = () => {
    this.setState({
      showModal: false,
      clientData: {
        id: '',
        firstName: '',
        lastName: ' ',
        phone: '',
        email: '',
        notes: '',
        findClient: false,
        reaction: '',
        from: '',
      },
      formData: {
        userId: auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
        validDate: '',
        destination: '',
        interest: '',
        adults: '',
        juniors: '',
        kids: '',
        notesQuotation: '',
        assignedTo:
          auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
        executive: auth.getCurrentUser() !== null ? auth.getCurrentUser() : '',
        group: false,
        down: false,
        status: 'leats',
      },
      dates: {
        departureDate: calendarDayToUtc(moment()),
        returnDate: calendarDayToUtc(moment()),
        openDate: false,
        duration: '',
      },
      openDateDisabled: false,
    });
  };

  getOptionsSelect = async (name, url, optionCreateFunction) => {
    let response = await axios.get(url);
    let options = [];
    response.data.map((option) => {
      options.push(optionCreateFunction(option));
    });

    options.sort((a, b) => {
      const labelA = a.label.toLowerCase();
      const labelB = b.label.toLowerCase();
      return labelA.localeCompare(labelB);
    });

    this.setState({
      optionsSelect: {
        ...this.state.optionsSelect,
        [name]: options,
      },
      clients: response.data,
    });
  };

  handleChange(id, checked) {
    if (checked == true) {
      this.setState({
        dates: {
          ...this.state.dates,
          openDate: true,
          returnDate: calendarDayToUtc(moment()),
          departureDate: calendarDayToUtc(moment()),
        },
        openDateDisabled: true,
      });
    } else {
      this.setState({
        dates: {
          ...this.state.dates,
          openDate: false,
          returnDate: calendarDayToUtc(moment()),
          departureDate: calendarDayToUtc(moment()),
        },
        openDateDisabled: false,
      });
    }
    this.onChange(id, checked);
  }

  calculate = () => {
    const startDate = moment(this.props.Quotations.dates.departureDate);
    const timeEnd = moment(this.props.Quotations.dates.returnDate);
    const diff = timeEnd.diff(startDate);
    const diffDuration = moment.duration(diff);
    const nights = diffDuration.days() - 1;
    this.setState({
      days: nights,
    });
  };

  save = async () => {
    let _this = this;
    return new Promise(async function (resolve, reject) {
      if (_this.state.clientData.findClient == false) {
        var newPostClient = {
          ..._this.state.clientData,
          assignedTo:
            auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
        };
        var createClient = await axios.post(
          process.env.REACT_APP_URL_API + '/api/clients',
          newPostClient
        );

        var newQuotationPost = {
          clientId: createClient.data.id,
          generalQuotation: _this.state.formData,
          dates: _this.state.dates,
          lodgings: [],
          flights: [],
          otherServices: [],
          packages: [],
          franchiseId: '',
          franchiseNumber: auth.getCurrentUser().franchise.privateId,
          assignedTo:
            auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
        };

        newQuotationPost.status = 'leats';
        newQuotationPost.ordenGenerated = false;

        var saveQuotation = axios
          .post(
            process.env.REACT_APP_URL_API + '/api/quotations',
            newQuotationPost
          )
          .then(function (res) {
            resolve(res);
          });

        //this.onCloseModal;
      } else {
        var createClient = await axios.patch(
          process.env.REACT_APP_URL_API +
            '/api/clients/' +
            _this.state.clientData.id,
          _this.state.clientData
        );

        var newQuotationPost = {
          clientId: _this.state.clientData.id,
          generalQuotation: _this.state.formData,
          dates: _this.state.dates,
          lodgings: [],
          flights: [],
          otherServices: [],
          packages: [],
          franchiseId: '',
          franchiseNumber: auth.getCurrentUser().franchise.privateId,
          assignedTo:
            auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
        };

        newQuotationPost.status = 'leats';
        newQuotationPost.ordenGenerated = false;

        var saveQuotation = axios
          .post(
            process.env.REACT_APP_URL_API + '/api/quotations',
            newQuotationPost
          )
          .then(function (res) {
            resolve(res);
          });
      }
    });
  };

  handledCompleteForm = async (event) => {
    event.preventDefault();
    let _this = this;
    this.setState({ loading: true });

    _this.save().then(function (res) {
      _this.handleRedirect(res);
    });
  };

  handleRedirect = function (res) {
    console.log('res----------------', res);
    if (res.status == 200) {
      this.setState({ loading: false });
      window.location.href = '/#/admin/quotations/' + res.data.id;

      this.onCloseModal();
    } else {
      //console.log('Error', res);
    }
  };

  onCloseModal = () => {
    this.setState({
      showModal: false,
      clientData: {
        firstName: '',
        lastName: ' ',
        phone: '',
        email: '',
        notes: '',
        findClient: false,
        saludation: '',
        reaction: '',
        from: '',
      },
      formData: {
        userId: auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
        validDate: '',
        destination: '',
        interest: '',
        adults: '',
        juniors: '',
        kids: '',
        notesQuotation: '',
        assignedTo:
          auth.getCurrentUser() !== null ? auth.getCurrentUser().id : '',
        executive: auth.getCurrentUser() !== null ? auth.getCurrentUser() : '',
        group: false,
        down: false,
        status: 'leats',
      },
      dates: {
        departureDate: calendarDayToUtc(moment()),
        returnDate: calendarDayToUtc(moment()),
        openDate: false,
        duration: '',
      },
    });
  };

  onChangeDates = (path, value) => {
    var newFormData = immutable.set(this.state.dates, path, value);

    this.setState({
      dates: newFormData,
    });
  };

  onChangeClient = (path, value) => {
    var newFormData = immutable.set(this.state.clientData, path, value);

    this.setState({
      clientData: newFormData,
    });
  };

  onChange = (path, value) => {
    var newFormData = immutable.set(this.state.formData, path, value);

    this.setState({
      formData: newFormData,
    });
  };

  findClient = (value) => {
    let { nam, las, ema, pho, not } = '';
    axios
      .get(process.env.REACT_APP_URL_API + '/api/clients/' + value)
      .then((res) => {
        this.setState({
          clientData: {
            id: res.data.id,
            firstName: res.data.firstName,
            lastName: res.data.lastName,
            phone: res.data.phone,
            email: res.data.email,
            notes: res.data.notes,
            saludation: res.data.saludation,
            from: res.data.from,
            findClient: true,
            otherContact: res.data.otherContact,
          },
        });
      });
  };

  copyTheName = (name) => {
    this.setState({
      clientData: {
        ...this.state.clientData,
        firstName: name,
      },
    });
  };

  handleRangeChange = (payload) => {
    let endDate = calendarDayToUtc(payload.selection.endDate);
    let startDate = calendarDayToUtc(payload.selection.startDate);

    const diff = endDate.diff(startDate, 'days');

    this.setState({
      days: diff,
      dates: {
        ...this.state.dates,
        returnDate: endDate,
        departureDate: startDate,
      },
    });
  };

  render() {
    const { optionsSelect, listSalesNotifications } = this.state;

    const ComponentNotification = () => {
      return (
        <GridStyled fluid>
          <Row>
            <Col md={12} lg={12}>
              <SpanStyled>Notificaciones</SpanStyled>
              <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                {Object.keys(listSalesNotifications).map(function (key, index) {
                  return (
                    <div>
                      {listSalesNotifications[key].color &&
                      listSalesNotifications[key].color === 'Red' ? (
                        <i class="fa fa-circle" style={{ color: '#FF0000' }} />
                      ) : (
                        <div />
                      )}

                      {listSalesNotifications[key].color &&
                      listSalesNotifications[key].color === 'Yellow' ? (
                        <i class="fa fa-circle" style={{ color: '#ffff00' }} />
                      ) : (
                        <div />
                      )}
                      <ListItem
                        label={listSalesNotifications[key].label}
                        id={listSalesNotifications[key].id}
                      />
                    </div>
                  );
                })}
              </div>
            </Col>
          </Row>
        </GridStyled>
      );
    };
    const styles = {
      label: {
        fontWeight: '400',
      },
      title: {
        color: '#497dc1',
        fontSize: '18px',
      },
    };

    return (
      <Grid fluid>
        <div className="pull-right">
          <Button
            fill
            bsStyle="primary"
            style={{ marginRight: 10 }}
            onClick={() => this.setState({ showModal: true })}
          >
            Atención a Clientes
          </Button>
          <Nav pullRight>
            <NavDropdown
              eventKey={5}
              title={
                <div style={{ position: 'relative', display: 'inline-block' }}>
                  {listSalesNotifications && listSalesNotifications.length ? (
                    <div>
                      <i className="fa fa-bell" style={{ color: '#007bff' }} />
                      <span
                        className="notification-badge"
                        style={{ color: '#007bff' }}
                      >
                        {listSalesNotifications.length}
                      </span>
                    </div>
                  ) : (
                    <div>
                      <i className="fa fa-bell-slash" />
                      <span className="notification-badge">0</span>
                    </div>
                  )}
                  <p className="hidden-md hidden-lg ">
                    SOPORTE
                    <b className="caret" />
                  </p>
                </div>
              }
              noCaret
              id="basic-nav-dropdown-3"
              bsClass="dropdown-with-icons dropdown"
              className="hidden-sm"
            >
              <ComponentNotification />
              {/*CREAR COMPONENTE DE NOTIFICACIONES */}
              {/*<GridStyled fluid>
                <Row>
                  <Col md={12} lg={12}>
                    <SpanStyled> Próximas Actualizaciones</SpanStyled>
                    {Object.keys(list).map(function (key, index) {
                      return (
                        <ListItem
                          icon={Logo}
                          widthIcon={'18px'}
                          label={list[key].label}
                        />
                      );
                    })}
                  </Col>
                </Row>
              </GridStyled>*/}
            </NavDropdown>
            <NavDropdown
              eventKey={4}
              title={
                <div>
                  <i className="fa fa-list" />
                  <p className="hidden-md hidden-lg">
                    SESIÓN
                    <b className="caret" />
                  </p>
                </div>
              }
              noCaret
              id="basic-nav-dropdown-3"
              bsClass="dropdown-with-icons dropdown"
            >
              <MenuItem eventKey={4.5} onClick={this.logout}>
                <div className="text-danger">
                  <i className="pe-7s-close-circle" /> Salir
                </div>
              </MenuItem>
            </NavDropdown>
          </Nav>
        </div>

        <Modal
          open={this.state.showModal}
          onClose={this.onCloseModal}
          styles={{
            modal: { width: '100%' },
            overlay: { alignItems: 'flex-start' },
          }}
          closeOnOverlayClick={false}
        >
          {this.state.loading ? (
            <Loading />
          ) : (
            <form onSubmit={this.handledCompleteForm}>
              <Grid fluid>
                <h5>Atención a Clientes</h5>

                <Row>
                  <Col md={6}>
                    <h5 style={styles.title}>Información del cliente</h5>

                    <WidgetSearchName
                      schema={{
                        creatable: false,
                        title: 'Buscar cliente por nombre, telefono o correo',
                        api: process.env.REACT_APP_URL_API + '/api/clients',
                      }}
                      value={''}
                      required={false}
                      onChange={(value) => this.findClient(value)}
                      onCreate={(value) => this.copyTheName(value)}
                    />
                    <br />

                    <div className="form-group">
                      <label htmlFor="firstName" style={styles.label}>
                        Saludo
                      </label>
                      <Select
                        required
                        placeholder="-- Seleccionar"
                        name="userId"
                        value={this.state.clientData.saludation}
                        options={saludation}
                        onChange={(event) => {
                          if (event) {
                            this.onChangeClient('saludation', event.value);
                          } else {
                            this.onChangeClient('saludation', '');
                          }
                        }}
                      />
                      <input
                        style={{
                          height: 1,
                          padding: 0,
                          margin: 0,
                          border: 0,
                          color: 'white',
                        }}
                        required
                        type="text"
                        id="userIdHidden"
                        value={this.state.clientData.saludation}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="from" style={styles.label}>
                        Medio de Contacto
                      </label>
                      <Select
                        required
                        placeholder="-- Seleccionar"
                        name="from"
                        value={this.state.clientData.from}
                        options={fromArray}
                        onChange={(event) => {
                          if (event) {
                            this.onChangeClient('from', event.value);
                          } else {
                            this.onChangeClient('from', '');
                          }
                        }}
                      />
                      <input
                        style={{
                          height: 1,
                          padding: 0,
                          margin: 0,
                          border: 0,
                          color: 'white',
                        }}
                        type="text"
                        id="userIdHidden"
                        value={this.state.clientData.from}
                      />
                    </div>

                    {this.state.clientData.from === 'others' && (
                      <div className="form-group">
                        <label htmlFor="otherContact" style={styles.label}>
                          Especificar otro medio
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="otherContact"
                          value={this.state.clientData.otherContact}
                          onChange={(event) =>
                            this.onChangeClient(
                              'otherContact',
                              event.target.value
                            )
                          }
                        />
                      </div>
                    )}

                    <div className="form-group">
                      <label htmlFor="firstName" style={styles.label}>
                        Nombre
                      </label>
                      <input
                        required
                        type="text"
                        className="form-control"
                        id="firstName"
                        value={this.state.clientData.firstName}
                        onChange={(event) =>
                          this.onChangeClient('firstName', event.target.value)
                        }
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="lastName" style={styles.label}>
                        Apellidos
                      </label>
                      <input
                        required
                        type="text"
                        className="form-control"
                        id="lastName"
                        value={this.state.clientData.lastName}
                        onChange={(event) =>
                          this.onChangeClient('lastName', event.target.value)
                        }
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="phone" style={styles.label}>
                        Teléfono celular
                      </label>
                      <input
                        required
                        type="text"
                        className="form-control"
                        id="phone"
                        value={this.state.clientData.phone}
                        onChange={(event) =>
                          this.onChangeClient('phone', event.target.value)
                        }
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="email" style={styles.label}>
                        Email
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="email"
                        value={this.state.clientData.email}
                        onChange={(event) =>
                          this.onChangeClient('email', event.target.value)
                        }
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="notes" style={styles.label}>
                        Notas del cliente
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        id="notes"
                        value={this.state.clientData.notes}
                        onChange={(event) =>
                          this.onChangeClient('notes', event.target.value)
                        }
                      />
                    </div>
                  </Col>

                  <Col md={6}>
                    <h5 style={styles.title}>Información de la Cotización</h5>
                    <div className="form-group">
                      <label htmlFor="client" style={styles.label}>
                        Asignado a
                      </label>
                      <Select
                        placeholder="-- Seleccionar"
                        name="userId"
                        value={this.state.formData.userId}
                        options={optionsSelect.users}
                        onChange={(event) => {
                          if (event) {
                            this.onChange('userId', event.value);
                          } else {
                            this.onChange('userId', '');
                          }
                        }}
                      />
                      <input
                        style={{
                          height: 1,
                          padding: 0,
                          margin: 0,
                          border: 0,
                          color: 'white',
                        }}
                        required
                        type="text"
                        id="userIdHidden"
                        value={this.state.formData.userId}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="validDate" style={styles.label}>
                        Válido hasta
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="validDate"
                        value={this.state.formData.validDate}
                        onChange={(event) =>
                          this.onChange('validDate', event.target.value)
                        }
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="reference" style={styles.label}>
                        Destino
                      </label>
                      <input
                        type="text"
                        required
                        className="form-control"
                        id="destination"
                        value={this.state.formData.destination}
                        onChange={(event) =>
                          this.onChange('destination', event.target.value)
                        }
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="reference" style={styles.label}>
                        Interés
                      </label>
                      <Select
                        placeholder="-- Seleccionar"
                        name="interest"
                        value={this.state.formData.interest}
                        options={options}
                        onChange={(event) => {
                          if (event) {
                            this.onChange('interest', event.value);
                          } else {
                            this.onChange('interest', '');
                          }
                        }}
                      />
                    </div>
                    <Row>
                      <Col md={4}>
                        <div className="form-group">
                          <label htmlFor="reference">Adultos</label>
                          <Select
                            placeholder="-- Elegir"
                            name="adults"
                            value={this.state.formData.adults}
                            options={people}
                            onChange={(event) => {
                              if (event) {
                                this.onChange('adults', event.value);
                              } else {
                                this.onChange('adults', '');
                              }
                            }}
                          />
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="form-group">
                          <label htmlFor="reference">Juniors</label>
                          <Select
                            placeholder="-- Elegir"
                            name="juniors"
                            value={this.state.formData.juniors}
                            options={people}
                            onChange={(event) => {
                              if (event) {
                                this.onChange('juniors', event.value);
                              } else {
                                this.onChange('juniors', '');
                              }
                            }}
                          />
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="form-group">
                          <label htmlFor="reference">Niños</label>
                          <Select
                            placeholder="-- Elegir"
                            name="kids"
                            value={this.state.formData.kids}
                            options={people}
                            onChange={(event) => {
                              if (event) {
                                this.onChange('kids', event.value);
                              } else {
                                this.onChange('kids', '');
                              }
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="form-group">
                      <label htmlFor="reference" style={styles.label}>
                        Observaciones de la cotización
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        id="notesQuotation"
                        value={this.state.formData.notes}
                        onChange={(event) =>
                          this.onChange('notes', event.target.value)
                        }
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="trackingLine" style={styles.label}>
                        Línea de Seguimiento
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        id="trackingLine"
                        value={this.state.formData.trackingLine}
                        onChange={(event) =>
                          this.onChange('trackingLine', event.target.value)
                        }
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="openDate" style={styles.label}>
                        Fecha abierta de cotización
                      </label>
                    </div>
                    <div className="form-group">
                      <Switch
                        checked={this.state.dates.openDate}
                        onChange={(checked) =>
                          this.handleChange('openDate', checked)
                        }
                      />
                    </div>

                    {!this.state.openDateDisabled ? (
                      <div>
                        <DateRange
                          onChange={this.handleRangeChange}
                          moveRangeOnFirstSelection={false}
                          months={2}
                          locale={rdrLocales['es']}
                          minDate={new Date()}
                          ranges={[
                            {
                              startDate: this.state.dates.departureDate,
                              endDate: this.state.dates.returnDate,
                              key: 'selection',
                            },
                          ]}
                          className={'PreviewArea'}
                        />
                        <input
                          style={{
                            height: 1,
                            padding: 0,
                            margin: 0,
                            border: 0,
                            color: 'white',
                          }}
                          required
                          type="text"
                          id="userIdHidden"
                          value={this.state.dates.departureDate}
                        />
                      </div>
                    ) : null}

                    {!this.state.openDateDisabled ? (
                      <Row>
                        <Col md={3}>
                          <div className="form-group">
                            <label htmlFor="duration">Duración (noches)</label>
                            <input
                              id="activityInput"
                              className="form-control"
                              rows="1"
                              value={this.state.days}
                              onChange={(event) =>
                                this.props.dispatch(
                                  QuotationsActions.onChange(
                                    ['dates', 'duration'],
                                    event.target.value
                                  )
                                )
                              }
                              disabled
                              name="body"
                              type="number"
                            />
                          </div>
                        </Col>
                      </Row>
                    ) : null}
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className={'pull-right'} style={{ marginBottom: 15 }}>
                      <Button
                        bsStyle="primary"
                        style={{ marginRight: 10 }}
                        onClick={this.onCloseModal}
                      >
                        Regresar
                      </Button>
                      <Button bsStyle="primary" fill type="submit">
                        Guardar
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Grid>
            </form>
          )}
        </Modal>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Quotations: state.Quotations,
    Clients: state.Clients,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ClientsActions: bindActionCreators(ClientsActions, dispatch),
    QuotationsActions: bindActionCreators(QuotationsActions, dispatch),
  };
};

const HeaderLinksConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderLinks);

const SpanStyled = styled.span`
  font-weight: 400;
  font-size: 1.2em;
  color: #4972b1;
  margin-left: 8px;
`;

const GridStyled = styled(Grid)`
  width: 400px;
  margin-bottom: 8px;
  margin-top: 8px;
  padding-left: 8px;
  padding-right: 8px;
`;

export default HeaderLinksConnect;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx